import { render, staticRenderFns } from "./TabsItems.vue?vue&type=template&id=01f91312&scoped=true&"
import script from "./TabsItems.vue?vue&type=script&lang=js&"
export * from "./TabsItems.vue?vue&type=script&lang=js&"
import style0 from "./TabsItems.vue?vue&type=style&index=0&id=01f91312&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "01f91312",
  null
  
)

export default component.exports